import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupUnion: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="boolean-group-union"><path d="M11.75 2C9.67893 2 8 3.67893 8 5.75V8H5.75C3.67893 8 2 9.67893 2 11.75V18.25C2 20.3211 3.67893 22 5.75 22H12.25C14.3211 22 16 20.3211 16 18.25V16H18.25C20.3211 16 22 14.3211 22 12.25V5.75C22 3.67893 20.3211 2 18.25 2H11.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBooleanGroupUnion;
